/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
    logo: {
        width: 16,
        height: 16,
        viewBox: '0 0 40 14',
        data:
            '<path pid="0" id="Combined-Shape" class="st0" d="M4.3 0l2.4 10.7L9.1 0h4.2v14h-2.7V2.4L7.9 14H5.5L2.7 2.4V14H0V0h4.3zM40 0v2.4h-6.6v3.3H39v2.2h-5.7V14h-2.6V0H40zM19.7 0L22 10.7 24.5 0h4.2v14H26V2.4L23.3 14h-2.4L18.1 2.4V14h-2.7V0h4.3z"/>'
    }
})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/icons/logo.ts